import { render, staticRenderFns } from "./MoneyManager.template.vue?vue&type=template&id=338c0a3a&scoped=true&"
var script = {}
import style0 from "./MoneyManager.template.vue?vue&type=style&index=0&id=338c0a3a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338c0a3a",
  null
  
)

export default component.exports